import api from '@/api';

export function getFeedbackFormText() {
  return api.get<{ data: {
    attributes: {
      feedback_form_text: string
    }
  }}>('/feedback-form');
}

export function sendFeedbackForm(formData: FormData) {
  return api.post('/feedbacks', formData)
}
